import { useQuery } from 'react-query';
import { EMPTY_LOCATIONS } from 'shared/helpers/locationsCache';


export const LOCATIONS_KEY = ['locations'];

export const useLocations = () => {
  const { data } = useQuery(LOCATIONS_KEY, () => EMPTY_LOCATIONS, {
    enabled: false,
    staleTime: Infinity,
  });

  return data ?? EMPTY_LOCATIONS;
};
